

import 'jquery';
import toastr from 'toastr';
window.toastr = toastr;

import 'bootstrap';


import "../vendor/mdb";
import 'crypto-js';

import moment from 'moment';
window.moment = moment;
import '@pwabuilder/pwainstall'
import "datatables.net";
import 'jquery-ui-bundle';
import 'jsbarcode';
import 'fullcalendar';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-ajax-unobtrusive';

// Import de la librairie des masques de saisies (utilisé dans init.js)
import Inputmask from 'inputmask';

import "popper.js";
import 'fullcalendar';

//Importation des variables globales paratgées par less, Javascript et Core
import GlobalNav from './GlobalNav.json';
window.GlobalNav = GlobalNav;

window.CryptoJS = require("crypto-js");
window.axios = require("axios");
window.PerfectScrollbar = require('perfect-scrollbar').default;


import './GlobalVars';
import './FormatScreen';
import './Navigation';
import './CustomUnobtrusive';
import './CustomValidator';
import './PageUtils';
import './RendezVous';
import './Utils';
import './init';
